
<div class="col text-center">
    <div class="row justify-content-center">
        <div class="dialog-title-box">
            <div class="col">
                <div class="row">
                    <div class="col pt-3">
                        <i [ngClass]="data.icon" class=" icon" id="questionIcon"></i>
                    </div>
                </div>
                <div class="row">
                    <div class="col pb-3 pt-3">
                        <span id="confirmation" class="title pb-1 mt-3 mb-3">
                            {{data.title}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<mat-dialog-content class="mat-typography mat-dialog-content mat-dialog-container-Edit">
<div class="col p-0">
    <h2 class="col maincontent pt-4 mb-1 text-center" id="confirmation">
        {{data.message}}
    </h2>

    <div class="form-group" [formGroup]="SessionForm">
        <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>Session</mat-label>
            <mat-select #select232 placeholder="Session" class="colorblack">
                <mat-select-filter *ngIf="select232.focused" formControlName="SessionId"
                [placeholder]="'Filter'" [displayMember]="'SnName'"
                [array]="sessionList" 
                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                <mat-option *ngFor="let item of SessionFilterList"
                [value]="item.SnNo" (click)="onSelect(item.SnNo)">
                {{item.SnName}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
   
    <h2 class="col subcontent mb-2 text-center" id=""></h2>
</div>
<div class="col text-center pb-3">
    <div class="row">
        <div class="justify-content-center">
            
            <!-- <button tabindex="1" type="button" id="" (click)="onSessionSelected()"
                class="btn btn-primary  center-block w-70">
                Submit
            </button> -->
            <button (click)="Close()" tabindex="1" type="button" id=""
                class="btn btn-primary center-block w-70">
                Close
            </button>
            <button tabindex="1" type="button" id="" (click)="onSessionSelected()"
                class="btn btn-primary ml2 center-block w-70">
                Submit
            </button>
        </div>
    </div>
</div>
</mat-dialog-content>